import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  findDotdigitalAccountKey,
  getDamAccountPath,
} from './findDotdigitalAccountKey';

const hasAccountId = (
  ddAccountId: string | number | null | undefined
): ddAccountId is string | number =>
  ddAccountId != null && String(ddAccountId).trim() !== '';

export const DamAccountLink = ({
  ddAccountId,
  children,
  className,
}: {
  ddAccountId: string | number | null | undefined;
  children: React.ReactNode;
  className?: string;
}) => {
  const [accountKey, setAccountKey] = useState<string | null>(null);
  const [lookupComplete, setLookupComplete] = useState(false);

  useEffect(() => {
    let cancelled = false;

    if (!hasAccountId(ddAccountId)) {
      setAccountKey(null);
      setLookupComplete(true);
      return;
    }

    setLookupComplete(false);
    findDotdigitalAccountKey(ddAccountId).then((key) => {
      if (!cancelled) {
        setAccountKey(key);
        setLookupComplete(true);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [ddAccountId]);

  if (!hasAccountId(ddAccountId) || (lookupComplete && !accountKey)) {
    return <>{children}</>;
  }

  const href = accountKey ? getDamAccountPath(accountKey) : '#';

  const handleClick = async (
    event: React.MouseEvent<HTMLAnchorElement>
  ) => {
    event.stopPropagation();

    if (accountKey) {
      return;
    }

    event.preventDefault();
    const key = await findDotdigitalAccountKey(ddAccountId);
    if (key) {
      window.open(getDamAccountPath(key), '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      title="Open account in DAM"
      onClick={handleClick}
    >
      {children}
    </a>
  );
};
